/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="86.12"
        height="95.45"
        viewBox="0 0 86.12 95.45"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M38.93.32a1.26 1.26 0 0 1 1.67 0c10.2 9.15 22.39 13.73 37.72 14.19a1.25 1.25 0 0 1 1.2 1.12v19.96a1.25 1.25 0 1 1-2.5-.07V16.93h-.25c-14.72-.7-26.71-5.2-36.82-13.89l-.18-.14-.17.14c-9.94 8.54-21.7 13-36.09 13.85h-1v14c0 14.78 1.52 25.43 5.83 34.89l.25.52C14.15 78.17 24.02 87 39.52 92.72l.25.09.46-.17a69.55 69.55 0 0 0 11.78-5.61l.69-.43a1.24 1.24 0 0 1 1.72.39 1.26 1.26 0 0 1-.39 1.73 71.82 71.82 0 0 1-13.83 6.6 1.24 1.24 0 0 1-.85 0c-16.5-5.93-27.09-15.3-33-27.95C2.5 59.15.72 50.2.2 38.74l-.06-1.51V15.76a1.25 1.25 0 0 1 1.21-1.25C16.54 14.05 28.77 9.47 38.93.32Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M59.31 37.15a1.25 1.25 0 0 1 1.42 1.05 1.24 1.24 0 0 1-1 1.42 20.79 20.79 0 1 0 6.34 0 1.24 1.24 0 0 1-1-1.42 1.27 1.27 0 0 1 1.43-1 23.27 23.27 0 1 1-7.11 0Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M51.77 35.2a1.25 1.25 0 0 1 1.51-.71h.12l6.59 2.74a1.253 1.253 0 0 1-.84 2.36l-.12-.05-6.59-2.74a1.25 1.25 0 0 1-.67-1.6Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M58.47 37.69a1.25 1.25 0 0 1 2.09 1.37l-.08.11-4.29 5.84a1.25 1.25 0 0 1-2.09-1.37l.07-.11Z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M62.64 44.26a1.24 1.24 0 0 1 1.24 1.12v12.81h12.89a1.26 1.26 0 0 1 1.25 1.12v.13a1.25 1.25 0 0 1-1.12 1.24H62.64a1.25 1.25 0 0 1-1.24-1.13V45.51a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithClock360ArrowIcon';

export default Icon;
